import { getOneWayRentalResFlow } from "selectors/reservationSelectors";
import { getInitialCarClassCode } from "selectors/progressBarSelectors";
import { initiateReservationFlow } from "actions/reservation/initiateReservationFlow";
import { actions } from "@ehi/global-marketing-interface";

const {
  initiateState,
} = actions.reservations;

export const updateReservationFlowLocation = (location, exchangeType) => (dispatch, getState) => {
    const state = getState();
    const isOneWayRes = getOneWayRentalResFlow(state);
    const carClass = getInitialCarClassCode(state);

    if (carClass) {
        dispatch(initiateState.set('car_class', { code: carClass }));
    }

    return dispatch(
        initiateState.set('location', {
            location,
            ...(isOneWayRes && { exchangeType }),
        })
    ).then(() => dispatch(initiateReservationFlow({ saveLatestSelections: true, preserveBundleProfile: true })));
};